<template>
  <div class="popup" v-if="popup" key="popup">
    <div class="conteudo">
      <button>
        <img
          src="@/assets/imgs/icone_fechar_roxo_borda.png"
          alt="Fechar"
          class="fechar"
          @click="closePopup"
        />
      </button>

      <a href="javascript:void(0)" @click="goToPage(informativo)">
        <img :src="informativo.imagem" alt="Popup" class="fundo" />
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'PopUp',
  props: {
    imagem: {
      type: String,
      default: 'default_popup',
    },
    link: {
      type: String,
      default: '#',
    },
  },
  computed: {
    ...mapGetters({
      informativo: 'midia/informativo',
      popup: 'midia/popup',
      changeUF: 'user/uf',
    }),
  },
  methods: {
    goToPage(data) {
      const { link, tab } = data;

      if (!link) return;

      const openNewTab = !!+tab;
      document.body.removeAttribute('style');
      this.changeStatusPopup(false);

      if (!openNewTab) window.open(link, '_blank');
      else window.open(link, '_self');
    },
    closePopup() {
      this.changeStatusPopup(false);
    },
    ...mapActions({
      getMidiaVivoInformativo: 'midia/getMidiaVivoInformativo',
      changeStatusPopup: 'midia/changeStatusPopup',
    }),
  },
  mounted() {
    this.getMidiaVivoInformativo();
  },
  watch: {
    changeUF(after) {
      if (after) this.getMidiaVivoInformativo();
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.popup {
  z-index: 15000;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  position: fixed;
  background: rgba(0, 0, 0, 0.95);

  & .conteudo {
    position: relative;
    width: 980px;
    height: 500px;
    margin-left: -7px;

    & button {
      cursor: pointer;
      position: absolute;
      background: none;
      border: none;
      padding: 0px;
      top: 15px;
      right: 15px;
      z-index: 1;
      transition: all 0.2s ease-in-out;
      outline: none;
      border-radius: 50px;

      &:hover {
        transform: scale(1.1);
      }
    }

    & a {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      margin: 0px;
      padding: 0px;

      & .fundo {
        width: 100%;
        height: 100%;
        /*max-width: 980px;*/
        /*max-height: 550px;*/
        border-radius: 5px;
        object-fit: cover;
      }
    }
  }
}

@media all and (min-width: 300px) and (max-width: 679px) {
  .popup {
    & .conteudo {
      width: 90vw;
      height: 48vw;
      margin-left: 0px;

      & button {
        top: -23px;
        right: -23px;
      }
    }
  }
}

@media all and (min-width: 680px) and (max-width: 1000px) {
  .popup {
    & .conteudo {
      width: 90vw;
      height: 48vw;
      margin-left: 0px;

      & button {
        top: -23px;
        right: -23px;
      }
    }
  }
}
</style>
